<template>
	<el-row class="mainOnebox">
		<!-- 标题 -->
		<el-row class="mainOnebox_title">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item>PRODUCT</el-breadcrumb-item>
				<el-breadcrumb-item>Stair Nosing</el-breadcrumb-item>
			</el-breadcrumb>
		</el-row>
		<!-- 内容 -->
		<el-row class="mainOnebox_main">
			<div class="mainOnebox_main_list_remove" v-for="(item,i) in imgdata" :key="i" @click="routelist(i)" @mouseenter="changeActive($event)" @mouseleave="removeActive($event)">
				<img :src="item.url">
				<span class="mainOnebox_main_list_name">{{item.title}}</span>
			</div>
			<div class="mainOnebox_main_list_none"></div>
			<div class="mainOnebox_main_list_none"></div>
		</el-row>
	</el-row>
</template>

<script>
	export default {
		components: {
			// banner:banner,
		},
		data() {
			return {
				imgdata: [
					{url: require('@/assets/image/productType/StairNosing/HZ-S4010.jpg'),title: 'HZ-S4010',list1:'As picture / Customized',list2:'Aluminum + PU / Rubber',list3:'As picture / Customized',list4:'Matter surface',list5:'Extrusion forming',list6:'Hezone Tile',list7:'Anti-skidding for stairs or steps',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/StairNosing/HZ-S4014.jpg'),title: 'HZ-S4014',list1:'As picture / Customized',list2:'Aluminum + PU / Rubber',list3:'As picture / Customized',list4:'Matter surface',list5:'Extrusion forming',list6:'Hezone Tile',list7:'Anti-skidding for stairs or steps',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/StairNosing/HZ-S4016.jpg'),title: 'HZ-S4016',list1:'As picture / Customized',list2:'Aluminum + PU / Rubber',list3:'As picture / Customized',list4:'Matter surface',list5:'Extrusion forming',list6:'Hezone Tile',list7:'Anti-skidding for stairs or steps',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/StairNosing/HZ-S4018.jpg'),title: 'HZ-S4018',list1:'As picture / Customized',list2:'Aluminum + PU / Rubber',list3:'As picture / Customized',list4:'Matter surface',list5:'Extrusion forming',list6:'Hezone Tile',list7:'Anti-skidding for stairs or steps',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/StairNosing/HZ-S4019.jpg'),title: 'HZ-S4019',list1:'As picture / Customized',list2:'Aluminum + PU / Rubber',list3:'As picture / Customized',list4:'Matter surface',list5:'Extrusion forming',list6:'Hezone Tile',list7:'Anti-skidding for stairs or steps',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/StairNosing/HZ-S4023.jpg'),title: 'HZ-S4023',list1:'As picture / Customized',list2:'Aluminum + PU / Rubber',list3:'As picture / Customized',list4:'Matter surface',list5:'Extrusion forming',list6:'Hezone Tile',list7:'Anti-skidding for stairs or steps',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/StairNosing/HZ-S4027.jpg'),title: 'HZ-S4027',list1:'As picture / Customized',list2:'Aluminum + PU / Rubber',list3:'As picture / Customized',list4:'Matter surface',list5:'Extrusion forming',list6:'Hezone Tile',list7:'Anti-skidding for stairs or steps',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/StairNosing/HZ-S4028.jpg'),title: 'HZ-S4028',list1:'As picture / Customized',list2:'Aluminum + PU / Rubber',list3:'As picture / Customized',list4:'Matter surface',list5:'Extrusion forming',list6:'Hezone Tile',list7:'Anti-skidding for stairs or steps',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/StairNosing/HZ-S4030.jpg'),title: 'HZ-S4030',list1:'As picture / Customized',list2:'Aluminum + PU / Rubber',list3:'As picture / Customized',list4:'Matter surface',list5:'Extrusion forming',list6:'Hezone Tile',list7:'Anti-skidding for stairs or steps',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/StairNosing/HZ-S4032.jpg'),title: 'HZ-S4032',list1:'As picture / Customized',list2:'Aluminum + PU / Rubber',list3:'As picture / Customized',list4:'Matter surface',list5:'Extrusion forming',list6:'Hezone Tile',list7:'Anti-skidding for stairs or steps',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/StairNosing/HZ-S4036.jpg'),title: 'HZ-S4036',list1:'As picture / Customized',list2:'Aluminum + PU / Rubber',list3:'As picture / Customized',list4:'Matter surface',list5:'Extrusion forming',list6:'Hezone Tile',list7:'Anti-skidding for stairs or steps',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/StairNosing/HZ-S4037.jpg'),title: 'HZ-S4037',list1:'As picture / Customized',list2:'Aluminum + PU / Rubber',list3:'As picture / Customized',list4:'Matter surface',list5:'Extrusion forming',list6:'Hezone Tile',list7:'Anti-skidding for stairs or steps',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/StairNosing/HZ-S4038.jpg'),title: 'HZ-S4038',list1:'As picture / Customized',list2:'Aluminum + PU / Rubber',list3:'As picture / Customized',list4:'Matter surface',list5:'Extrusion forming',list6:'Hezone Tile',list7:'Anti-skidding for stairs or steps',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/StairNosing/HZ-S4039.jpg'),title: 'HZ-S4039',list1:'As picture / Customized',list2:'Aluminum + PU / Rubber',list3:'As picture / Customized',list4:'Matter surface',list5:'Extrusion forming',list6:'Hezone Tile',list7:'Anti-skidding for stairs or steps',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/StairNosing/HZ-S4040.jpg'),title: 'HZ-S4040',list1:'As picture / Customized',list2:'Aluminum + PU / Rubber',list3:'As picture / Customized',list4:'Matter surface',list5:'Extrusion forming',list6:'Hezone Tile',list7:'Anti-skidding for stairs or steps',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/StairNosing/HZ-S4045.jpg'),title: 'HZ-S4045',list1:'As picture / Customized',list2:'Aluminum + PU / Rubber',list3:'As picture / Customized',list4:'Matter surface',list5:'Extrusion forming',list6:'Hezone Tile',list7:'Anti-skidding for stairs or steps',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/StairNosing/HZ-S4046.jpg'),title: 'HZ-S4046',list1:'As picture / Customized',list2:'Aluminum + PU / Rubber',list3:'As picture / Customized',list4:'Matter surface',list5:'Extrusion forming',list6:'Hezone Tile',list7:'Anti-skidding for stairs or steps',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/StairNosing/HZ-S4047.jpg'),title: 'HZ-S4047',list1:'As picture / Customized',list2:'Aluminum + PU / Rubber',list3:'As picture / Customized',list4:'Matter surface',list5:'Extrusion forming',list6:'Hezone Tile',list7:'Anti-skidding for stairs or steps',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/StairNosing/HZ-S4048.jpg'),title: 'HZ-S4048',list1:'As picture / Customized',list2:'Aluminum + PU / Rubber',list3:'As picture / Customized',list4:'Matter surface',list5:'Extrusion forming',list6:'Hezone Tile',list7:'Anti-skidding for stairs or steps',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/StairNosing/HZ-S4049.jpg'),title: 'HZ-S4049',list1:'As picture / Customized',list2:'Aluminum + PU / Rubber',list3:'As picture / Customized',list4:'Matter surface',list5:'Extrusion forming',list6:'Hezone Tile',list7:'Anti-skidding for stairs or steps',list8:'R16',list9:'Direct Manufacturer',},
				],
				imgDatalis:3,//是从哪个分类进来的
			}
		},
		created() {
			this.setSessionData()
		},
		methods: {
			routelist(i) {
				this.$router.push({
					path: '/productList',
					query: {
						id: i,
						imgDataIndex:this.imgDatalis,//是从哪个分类进来的
					}
				})
			},
			changeActive(e) {
				e.currentTarget.className = 'mainOnebox_main_list';
			},
			removeActive(e) {
				e.currentTarget.className = 'mainOnebox_main_list_remove';
			},
			setSessionData(){
				sessionStorage.setItem('imgData'+this.imgDatalis,JSON.stringify(this.imgdata))
			}
		},

	}
</script>

<style lang="less" scoped>
	@vw: 19.2vw;

	.mainOnebox {
		background: url(~@/assets/image/home/home_bg1.jpg);

		.mainOnebox_title {
			width: 100%;
			padding-left: 7vw;
			margin: 0 auto;
			title-align: center;
			margin-top: 80/@vw;
			margin-bottom: 50/@vw;

			/deep/.el-breadcrumb {
				font-size: 24/@vw;
			}
		}

		.mainOnebox_main {
			max-width: 1530px;
			margin: 0 auto;
			height: auto;
			padding-bottom: 100/@vw;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: row;
			flex-wrap: wrap;

			.mainOnebox_main_list {
				width: 350px;
				height: 350px;
				margin: 1vh 1.5vw;
				position: relative;
				overflow: hidden;
				cursor: pointer;

				img {
					width: 350px;
					height: 350px;
					position: relative;
				}

				.mainOnebox_main_list_name {
					position: absolute;
					bottom: 0;
					height: 100%;
					width: 100%;
					font-weight: 700;
					color: #fafafa;
					width: 100%;
					z-index: 999;
					left: 0;
					display: flex;
					align-items: center;
					justify-content: center;
					background-color: #000000;
					background-color: rgba(51, 51, 51, 0.5);
					font-size: 20px;
					transition: all 0.5s ease 0s;
					cursor: pointer;
				}
			}
			.mainOnebox_main_list_remove {
				width: 350px;
				height: 350px;
				margin: 1vh 1.5vw;
				position: relative;
				overflow: hidden;
				cursor: pointer;

				img {
					width: 350px;
					height: 350px;
					position: relative;
				}

				.mainOnebox_main_list_name {
					display: none;
				}
			}
			.mainOnebox_main_list_none {
				width: 350px;
				margin: 1vh 1.5vw;
				height: 0px;
			}
		}
	}
</style>
